<template>
  <v-tooltip right :disabled="!isMini">
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-bind="attrs"
        :href="href"
        :rel="href && href !== '#' ? 'noopener' : undefined"
        :target="href && href !== '#' ? '_blank' : undefined"
        :to="item.to"
        active-class="gpr-sidebar-item--active"
        v-on="on"
      >
        <v-list-item-icon v-if="item.icon">
          <v-icon v-text="item.icon" />
        </v-list-item-icon>

        <v-list-item-icon v-if="item.image">
          <!--<span>{{ item.image }}</span>-->
          <img :src="item.image" width="30" />
        </v-list-item-icon>

        <v-list-item-content v-if="item.title">
          <v-list-item-title v-text="item.title" />
        </v-list-item-content>
      </v-list-item>
    </template>
    <span>{{ item.title }}</span>
  </v-tooltip>
</template>

<script>
import Themeable from 'vuetify/lib/mixins/themeable';

export default {
  name: 'BaseItem',

  mixins: [Themeable],

  props: {
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        image: undefined,
        title: undefined,
        to: undefined
      })
    },
    text: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    href() {
      return this.item.href || (!this.item.to ? '#' : undefined);
    },
    isMini() {
      return !this.$store.getters.SidebarExpand;
    }
  }
};
</script>
